import React from "react";
import { useSelector } from "react-redux";
import { getCurrentPage } from "../../reduxStore/slices/docUploadSlice";
import { DOC_UPLOAD_PAGE_STATE } from "../../utility/enums/common";
import { SelectDocumentsType } from "./SelectDocumentsType";
import DocumentWidgetList from "./DocumentWidget/DocumentWidgetList";
import { SelectFileToUpload } from "./SelectFileToUpload";

export const DocUpload = () => {
  const currentPageName = useSelector(getCurrentPage);

  const pagesList = {
    [DOC_UPLOAD_PAGE_STATE.SELECT_DOCUMENT_TYPE]: (
      <>
        <SelectDocumentsType />
        <DocumentWidgetList />
      </>
    ),
    [DOC_UPLOAD_PAGE_STATE.SELECT_FILE_TO_UPLOAD]: <SelectFileToUpload />,
  };

  return pagesList[currentPageName] || <SelectDocumentsType />;
};
